import { render } from "./DisabledParentProjectsMessage.vue?vue&type=template&id=20542586"
import script from "./DisabledParentProjectsMessage.vue?vue&type=script&lang=js"
export * from "./DisabledParentProjectsMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__